"use client";

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion, useAnimate } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import UserSettingsPrimaryWalletItem from "./UserSettingsPrimaryWalletItem";
import type { ApiWallet } from "@/generated/models/ApiWallet";
export default function UserSettingsPrimaryWallet(t0) {
  const $ = _c(37);
  const {
    wallets,
    selected,
    onSelect
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [iconScope, animateIcon] = useAnimate();
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleOpen = t1;
  let t2;
  if ($[2] !== animateIcon || $[3] !== iconScope || $[4] !== isOpen) {
    t2 = () => {
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: -90
        });
      }
    };
    $[2] = animateIcon;
    $[3] = iconScope;
    $[4] = isOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t2);
  const listRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useClickAway(listRef, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useKeyPressEvent("Escape", t4);
  const [title, setTitle] = useState("Select wallet");
  let t5;
  if ($[8] !== selected || $[9] !== wallets) {
    t5 = () => {
      const selectedWallet = wallets.find(w => w.wallet === selected);
      const displayName = selectedWallet?.display ?? selectedWallet?.wallet;
      setTitle(displayName ?? "Select wallet");
    };
    $[8] = selected;
    $[9] = wallets;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== selected) {
    t6 = [selected];
    $[11] = selected;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] !== onSelect) {
    t7 = wallet => {
      onSelect(wallet);
      setIsOpen(false);
    };
    $[13] = onSelect;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const selectWallet = t7;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-block tw-text-sm tw-font-semibold tw-leading-5 tw-text-iron-300">Primary wallet</span>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== title) {
    t9 = <span className="tw-text-iron-50">{title}</span>;
    $[16] = title;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9 || $[19] !== toggleOpen) {
    t10 = <button type="button" onClick={toggleOpen} className="tw-text-left tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-900 tw-text-iron-50 tw-font-normal tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-600 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out">{t9}</button>;
    $[18] = t9;
    $[19] = toggleOpen;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== iconScope) {
    t12 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3"><svg ref={iconScope} className="tw-h-5 tw-w-5 tw-text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">{t11}</svg></div>;
    $[22] = iconScope;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t12) {
    t13 = <div className="tw-mt-2 tw-relative">{t10}{t12}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isOpen || $[28] !== selectWallet || $[29] !== selected || $[30] !== wallets) {
    t14 = isOpen && <motion.div className="tw-origin-top-right tw-absolute tw-z-10 tw-right-0 tw-mt-1 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-absolute tw-z-10 tw-mt-1 tw-overflow-hidden tw-max-w-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-1 tw-flow-root tw-max-h-[calc(240px+_-5vh)] tw-overflow-x-hidden tw-overflow-y-auto"><ul className="tw-flex tw-flex-col tw-px-2 tw-mx-0 tw-mb-0 tw-list-none">{wallets.map(wallet_0 => <UserSettingsPrimaryWalletItem key={wallet_0.wallet} wallet={wallet_0} selected={selected} onSelect={selectWallet} />)}</ul></div></div></motion.div>;
    $[27] = isOpen;
    $[28] = selectWallet;
    $[29] = selected;
    $[30] = wallets;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14) {
    t15 = <AnimatePresence mode="wait" initial={false}>{t14}</AnimatePresence>;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t13 || $[35] !== t15) {
    t16 = <div className="tw-max-w-full tw-relative tw-mt-6" ref={listRef}>{t8}{t13}{t15}</div>;
    $[34] = t13;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
}